var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSelfPickup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 62,
    viewBox: "0 0 60 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.1285 1.77453C49.8705 4.96104 54.8958 12.343 57.6597 20.2134C60.4875 28.2654 61.2067 37.2599 57.2471 44.8248C53.3196 52.3284 45.4251 56.5113 37.3214 59.0703C29.2976 61.6041 20.2709 63.0602 13.0301 58.7878C6.06902 54.6806 4.11973 46.0578 2.06588 38.2683C0.176962 31.1044 -1.40177 23.4906 1.98409 16.895C5.36389 10.3111 12.4666 7.08944 19.415 4.47231C26.8283 1.68007 34.8037 -1.24025 42.1285 1.77453Z",
    fill: "#EFEFF1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 50.8184V22.6518L32 13.9851L51.5 22.6518V50.8184",
    stroke: "#94949F",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1665 33.4851H42.8332V50.8184H21.1665V37.8184H34.1665",
    stroke: "#94949F",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1667 50.8183V31.3183C34.1667 30.1217 33.1966 29.1516 32 29.1516H27.6667C26.47 29.1516 25.5 30.1217 25.5 31.3183V37.8183",
    stroke: "#94949F",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfPickup);
export default __webpack_public_path__ + "static/media/SelfPickup.48a73bcc4075aafbbcd4c325f5a6c380.svg";
export { ForwardRef as ReactComponent };